import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  ImageListItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { useFormik } from "formik";
import * as yup from "yup";
import { BOOKING_AS_OPTIONS, COMPARE_VALUE } from "../../config/constant";
import puravankarLogo from "../../assets/icons/puravankara-logo.svg";
import ProvidentLogo from "../../assets/icons/Provident.svg";
import PurvaLandLogo from "../../assets/icons/Purva Land 1.svg";
import SelectInput from "../../components/SelectInput";
import { useTranslation } from "react-i18next";
import Turnstile from "react-turnstile";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import { useParams, useHistory } from "react-router-dom";
import { createBooking } from "../new-booking-form/new-booking-form.slice";
import { getErrorMessage } from "../../utilis/common-funtions";
const { REACT_APP_BRANDLOGO_URL } = process.env;

// Simple landing selector to choose journey and call onContinue
// No persistence; only client-side routing as per requirement

const BookingJourneySelector = ({ onContinue, onError }) => {
  const { t } = useTranslation("common", { keyPrefix: "landingPage" });
  const { t: tButton } = useTranslation("common", { keyPrefix: "button" });
  const [captchaToken, setCaptchaToken] = useState("");
  const dispatch = useDispatch()
  const history = useHistory();
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const { oppId } = useParams();

  const { isLoading, enquiryDetails, projectBrandImage, projectId, brandId } = useSelector(
    (state) => state?.newBookingForm
  );

  const bookingJourneyFormik = useFormik({
    initialValues: {
      bookingAs: "",
    },
    validationSchema: yup.object().shape({
      bookingAs: yup.string().required(t("bookingAsValidation")),
    }),
    onSubmit: (values) => {
      //  handleContinue();
    },
  });

  const handleVerify = (token) => {
    setCaptchaToken(token);
  };

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };

  const handleContinue = () => {
    if (!bookingJourneyFormik.values.bookingAs) return;
    onContinue(bookingJourneyFormik.values.bookingAs);
  };

const isDisable =
    !bookingJourneyFormik.values.bookingAs || !captchaToken?.length;
  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleNext = async () => {
    const payload = {
      opportunityId: oppId,
      enquiryId: enquiryDetails?.data?.EnquiryReferenceNo,
      bookingAs: bookingJourneyFormik?.values?.bookingAs,
      lastStep: 0,
      projectId,
      brandId
    };

    try {
      const res = await dispatch(createBooking(payload)).unwrap();
      // Optionally navigate to next step
      if (res) {
        if (enquiryDetails?.data?.VoucherNumberEOI) {
          history.push(`/voucher-applicant-mapping/${oppId}`);
        } else {
          handleContinue();
        }
      }
    } catch (err) {
      console.error("Booking creation failed:", err);
      onError(getErrorMessage(err) || "Booking creation failed");
        if (err?.errors?.data) {
            history.push(`/group-listing/${err?.errors?.data}`);
        } 
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div
        style={{
          backgroundImage: `url("${REACT_APP_BRANDLOGO_URL + "/" + projectBrandImage
            }")`,
        }}
        className="applicantCountContainer applicantBackground"
      >
        <div className="overly">
          <div className="cardContainer">
            <div className="addScrollContainer">
              <Card className="cardContent">
                <form
                  className="addScrollContainerForm"
                  onSubmit={bookingJourneyFormik.handleSubmit}
                  onReset={bookingJourneyFormik.handleReset}
                >
                  <CardContent sx={{ p: 0 }}>
                    <ImageListItem
                      sx={{
                        mb: {
                          xs: 2,
                          sm: 3,
                          md: 5,
                        },
                      }}
                    >
                      {getBrandImage() ? (
                        <img src={getBrandImage()} alt="Puravankara Logo" />
                      ) : null}
                    </ImageListItem>
                    <Typography
                      className="BlackPearl"
                      sx={{
                        fontWeight: "600",
                        fontSize: "20px",
                        textAlign: "center",
                        lineHeight: "30px",
                        mb: 1,
                      }}
                    >
                      {t("title")}
                    </Typography>
                    <Typography
                      className="BlackPearl"
                      sx={{
                        fontWeight: "400",
                        fontSize: "14px",
                        textAlign: "center",
                        mb: 2,
                      }}
                    >
                      {t("description")}
                    </Typography>
                    <div className="selectInput">
                      <SelectInput
                        field={{
                          name: "bookingAs",
                          label: t("bookingAsLabel"),
                          required: true,
                          readonly: false,
                          options: BOOKING_AS_OPTIONS,
                          placeholder: "Select",
                          showIcon: false,
                        }}
                        formik={bookingJourneyFormik}
                      />
                    </div>
                  </CardContent>
                  <div className="captcha">
                    <Turnstile
                      sitekey={process.env.REACT_APP_CLOUDFLARE_SITE_KEY}
                      onVerify={handleVerify}
                      options={{ theme: "light" }}
                    />
                  </div>
                  <div style={{ display: "flex" }}>
                    <Button
                      type="submit"
                      disabled={isDisable}
                      className={isDisable ? "disableCTA" : ""}
                      sx={{
                        background: "#1A407D",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "700",
                        display: "block",
                        width: "45%",
                        height: "48px",
                        borderRadius: "8px",
                        textTransform: "capitalize",
                        margin: "0px auto 0px auto",
                        "&:hover": {
                          backgroundColor: "#0c2856",
                        },
                      }}
                      onClick={handleNext}
                    >
                      {tButton("next")}
                    </Button>
                  </div>
                </form>
              </Card>
            </div>
          </div>
        </div>
      </div>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default BookingJourneySelector;
